import React, { useState } from "react";
import axios from "axios";
import FileDownload from "js-file-download";

// const env = import.meta.env;
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchPolicyList = async (
  // userId: number,
  customerPorfileId: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Policy/Details/${customerPorfileId}`
    );

    //console.log("fetchPolicyList res", res.data);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const fetchPolicyById = async (policyId: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Policy/Id/${policyId}/Details`
    );

    //console.log("fetchPolicyById res", res.data);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const addPolicy = async (payload: any) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/api/Policy`, payload);
    // console.log("addPolicy res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const editPolicy = async (payload: any) => {
  try {
    const res = await axios.put(`${API_BASE_URL}/api/Policy`, payload);
    // console.log("editPolicy res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const deletePolicy = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Policy/Delete/Policies`,
      payload
    );
    // console.log("deletePolicy res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const fetchPolicyImportList = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/api/Policy/Import/Details`);
    // console.log("fetchPolicyImportList res", res);

    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const importPolicy = async (payload: any) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/api/Policy/List`, payload);
    // console.log("importPolicy res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const downloadPolicy = async (
  payload: any,
  companyProfileID: number
) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/PolicyGenerate/Document?CompanyProfileID=${companyProfileID}&PolicyId=${payload.policyID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadPolicy res", response, payload);
      FileDownload(response.data, `${payload.policyName}.docx`);
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const downloadAllPolicy = async (
  // userId: number,
  companyProfileID: number
) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/PolicyGenerate/Document?CompanyProfileID=${companyProfileID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadAllPolicy res", response, payload);
      FileDownload(response.data, `policies.zip`);
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};
